<template>
  <div class="line-chart card-wrapper" ref="chart"></div>
</template>

<script setup>
import * as echarts from "echarts";
import { defineProps, onMounted, ref } from "vue";

const props = defineProps({
  name: {
    type: String || Number,
    required: true,
  },
  data: {
    type: Array,
    required: true,
  },
});

const chart = ref();

const getLineOption = (xAxisData, seriesData) => {
  return {
    grid: { left: "50px", right: "50px", top: "60px", bottom: "30px" },
    tooltip: {
      trigger: "axis",
    },
    dataZoom:
      seriesData.length > 6
        ? [
            {
              height: 20,
              brushSelect: false,
            },
          ]
        : null,
    title: {
      text: `${props.name}渠道产品使用次数折线图`,
      left: "center",
      top: "10px",
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      name: "日期",
      axisLabel: {
        interval: 0, // 显示全部标签
      },
    },
    yAxis: {
      name: "次",
      type: "value",
      axisLine: {
        show: true,
      },
      boundaryGap: ['0%', '5%'],
      minInterval: 1,
      axisLine: {
        show: true,
        symbol: ["none", "arrow"],
        symbolOffset: 8,
        symbolSize: 10,
      },
    },
    series: [
      {
        name: "使用次数",
        data: seriesData,
        type: "line",
        label: {
          show: true,
          formatter: (params) => {
            const value = params.value || "";
            return value;
          },
        },
      },
    ],
  };
};

const getDate = (time) => {
  const s = new Date(time);
  const y = s.getFullYear();
  const m = s.getMonth() + 1;
  const d = s.getDate() > 9 ? s.getDate() : `0${s.getDate()}`;
  return `${y}-${m}-${d}`;
};

const getWeekList = (stime, etime) => {
  const day = new Date(stime).getDay();
  const dayTime = 24 * 60 * 60 * 1000;
  const weekTime = dayTime * 7;
  const weekStart = new Date(stime - day * dayTime + weekTime);
  const weekEnd = new Date(etime);

  let s = weekStart.getTime();
  let e = weekEnd.getTime();

  const weekList = [];

  while (s < e + weekTime) {
    weekList.push(getDate(s));
    s += weekTime;
  }

  return weekList;
};

const compareTime = (weekList, data) => {
  const seriesData = new Array(weekList.length).fill(0);

  let i = 0;
  let s = 0;
  while (i < data.length) {
    const { localDate, number } = data[i];
    while (new Date(weekList[s]).getTime() < new Date(localDate).getTime()) {
      s++;
    }
    seriesData[s] += number;
    i++;
  }
  return seriesData;
};

const sortByDate = (list) => {
  const sortlist = [];
  list.forEach((item) => {
    sortlist.push(...item.serialUsageList);
  });
  return sortlist.sort((a, b) => a.localDate - b.localDate);
};

const getLineData = (data) => {
  const list = [];
  Object.keys(data).forEach((key) => {
    list.push({
      localDate: key,
      number: data[key],
    });
  });
  list.sort((a, b) => new Date(a.localDate).getTime() - new Date(b.localDate).getTime());
  if (list.length === 0) return null;
  const startTime = new Date(list[0].localDate).getTime();
  const endTime = new Date(list[list.length - 1].localDate).getTime();
  const weekList = getWeekList(startTime, endTime);
  const countUseByWeek = compareTime(weekList, list);
  const line = getLineOption(weekList, countUseByWeek);
  return line;
};

onMounted(() => {
  const lineChart = echarts.init(chart.value);
  const lineOption = getLineData(props.data);
  lineChart.setOption(lineOption);
});
</script>

<style lang="less" scoped>
.card-wrapper {
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 20px;
}

.line-chart {
  width: calc(100% / 2 - 3%);
  height: 6rem;
  margin-bottom: 30px;
}
</style>
